export default "__VITE_ASSET__CsRataCx__"